(function () {
  const MIN_SLIDER_COUNT = 4;

  function initProductVideoSlider(root) {
    if (!root || !root.classList.contains('elite-pdp-videos') || root.dataset.videosSliderInit === 'true') {
      return;
    }
    root.dataset.videosSliderInit = 'true';

    const viewport = root.querySelector('[data-elite-videos-viewport]');
    const controls = root.querySelector('[data-elite-videos-controls]');
    const prev = root.querySelector('[data-elite-videos-prev]');
    const next = root.querySelector('[data-elite-videos-next]');
    const cards = root.querySelectorAll('.elite-video-card');
    const count = cards.length;

    if (count < MIN_SLIDER_COUNT) {
      root.classList.add('elite-videos-slider--static');
      if (controls) controls.hidden = true;
      return;
    }

    root.classList.remove('elite-videos-slider--static');
    if (controls) controls.hidden = false;
    if (!viewport || !prev || !next) return;

    const scrollStep = () => {
      const gap = parseFloat(getComputedStyle(viewport.querySelector('.elite-pdp-videos__row') || viewport).gap) || 12;
      const card = cards[0];
      if (!card) return Math.max(200, Math.round(viewport.clientWidth * 0.75));
      return card.getBoundingClientRect().width + gap;
    };

    const updateNav = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth - 2;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', () => {
      viewport.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      viewport.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initVideoModals(root) {
    if (!root || root.dataset.videoModalsInit === 'true') return;
    root.dataset.videoModalsInit = 'true';

    root.querySelectorAll('.elite-video-card').forEach((card) => {
      const playButton = card.querySelector('.elite-video-card__play');
      const modal = card.querySelector('.elite-video-modal');
      if (!playButton || !modal) return;

      const modalVideo = modal.querySelector('video');

      playButton.addEventListener('click', () => {
        modal.showModal();
        if (modalVideo) modalVideo.play();
      });

      modal.querySelector('.elite-video-modal__close').addEventListener('click', () => {
        modal.close();
      });

      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.close();
      });

      modal.addEventListener('close', () => {
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.elite-pdp-videos[data-elite-videos-slider]').forEach((root) => {
      initProductVideoSlider(root);
      initVideoModals(root);
    });
    document.querySelectorAll('.elite-section--videos').forEach(initVideoModals);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    section.querySelectorAll('.elite-pdp-videos[data-elite-videos-slider]').forEach((root) => {
      initProductVideoSlider(root);
      initVideoModals(root);
    });
    const videosSection = section.querySelector('.elite-section--videos');
    if (videosSection) initVideoModals(videosSection);
  });
})();
